import { Component, Input, OnInit } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-sageactive',
  templateUrl: './userapi-sageactive.component.html'
})
export class UserApiSageActiveComponent extends AbstractUserApiModalComponent implements OnInit {
  @Input() userApi: UserAPI;

  ngOnInit(): void {
    if (this.userApi) {
      this.userApi.valid = this.userApi.url !== undefined;
    }
  }
}
